"use strict";

var keyboardTrap = _interopRequireWildcard(require("makeup-keyboard-trap"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// REQUIRE
// const keyboardTrap = require('makeup-keyboard-trap');

// IMPORT

const trap = document.getElementById("trap");
const btn = document.querySelector("button");
btn.addEventListener("click", function () {
  if (this.getAttribute("aria-pressed") === "true") {
    keyboardTrap.untrap();
  } else {
    keyboardTrap.trap(this.parentNode);
  }
});
document.addEventListener("keyboardTrap", function (e) {
  console.log(this, e);
});
document.addEventListener("keyboardUntrap", function (e) {
  console.log(this, e);
});
trap.addEventListener("keyboardUntrap", function (e) {
  console.log(this, e);
  btn.innerText = "Trap";
  btn.setAttribute("aria-pressed", "false");
});
trap.addEventListener("keyboardTrap", function (e) {
  console.log(this, e);
  btn.innerText = "Untrap";
  btn.setAttribute("aria-pressed", "true");
});